module.exports = __webpack_public_path__ + "static/media/4.6cf5af7f.jpg";